import React from 'react';

import { useIntl } from 'react-intl';

import useLocation from 'hooks/location/use-location';
import { routes } from 'utils/routing';

import FooterContent from './footer';

const Footer = () => {
  const {
    location: { pathname },
  } = useLocation();

  const { formatMessage } = useIntl();

  // hiding footer on sign up / login flow
  if (
    pathname === formatMessage({ id: 'routes.signUp' }) ||
    pathname === formatMessage({ id: 'routes.signIn' }) ||
    pathname === routes.confirmOtp
  ) {
    return null;
  }

  return <FooterContent />;
};

export default Footer;
